// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__99xsA{
  align-items: center;
  display: flex;
  justify-content: center;
}

.styles_overlay__wifLN {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.styles_loading__mz6iI {
    align-items: center;
    display: flex;
    height: 10rem;
    justify-content: center;
    width: 10rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/Loading/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd","sourcesContent":[".container{\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.loading {\n    align-items: center;\n    display: flex;\n    height: 10rem;\n    justify-content: center;\n    width: 10rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__99xsA`,
	"overlay": `styles_overlay__wifLN`,
	"loading": `styles_loading__mz6iI`
};
export default ___CSS_LOADER_EXPORT___;
